import React, { useState, useEffect, StrictMode } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useLocation,
} from "react-router-dom";
import styled, { keyframes } from "styled-components";

import Header from "./components/common/Header";
import Footer from "./components/common/Footer";

import Home from "./pages/Home";
import About from "./pages/About";
import Clicks from "./pages/Clicks";
import Recognitions from "./pages/Recognitions";
import BlogList from "./pages/BlogList";
import Policy from "./pages/Policy";
import Contact from "./pages/Contact";
import BlogDeatils from "./pages/BlogDeatils";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Spinner = styled.div`
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top: 4px solid #009603;
  width: 30px;
  height: 30px;
  animation: ${spin} 1s linear infinite;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
`;

const BlurContainer = styled.div`
  filter: ${({ loading }) => (loading ? "blur(20px)" : "none")};
  transition: filter 0.3s ease;
`;

const App = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Start loading when route changes
    const handleStart = () => {
      setLoading(true);
    };

    // Stop loading after a timeout
    const handleComplete = () => {
      setLoading(false);
    };

    handleStart();
    const timer = setTimeout(handleComplete, 500); // Adjust time as needed
    return () => {
      clearTimeout(timer);
    };
  }, [location]);

  // Cache Busting and Data Fetching for API calls or assets (optional)
  useEffect(() => {
    const currentTime = new Date().getTime();
    const cacheBusterUrl = `${process.env.PUBLIC_URL}/image.jpg?v=${currentTime}`;
  }, []);

  return (
    <StrictMode>
      {loading && <Spinner />}
      <BlurContainer loading={loading}>
        <Header />
        <Switch>
          <Route
            path={`${process.env.PUBLIC_URL + "/"}`}
            component={Home}
            exact
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/about"}`}
            component={About}
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/clicks"}`}
            component={Clicks}
          />
          <Route
            path={`${process.env.PUBLIC_URL}/clicks-specific/:id`}
            component={Clicks}
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/recognitions"}`}
            component={Recognitions}
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/blogs"}`}
            component={BlogList}
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/policy"}`}
            component={Policy}
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/contact"}`}
            component={Contact}
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/blog-deatils"}`}
            component={BlogDeatils}
          />
        </Switch>
        <Footer />
      </BlurContainer>
    </StrictMode>
  );
};

export default function MainApp() {
  return (
    <Router basename="/">
      <App />
    </Router>
  );
}
